
import React from 'react';
import { NewBonusSection } from '@/types/analysisTypes';
import { RenderInsightContentProps } from './types';
import { renderListItems } from './ListRenderer';
import { isNewBonusFormat } from '@/utils/bonus-section';

export const NewFormatInsight: React.FC<RenderInsightContentProps> = ({ 
  insightKey, 
  bonusSection 
}) => {
  if (!isNewBonusFormat(bonusSection)) return null;
  
  const newBonusSection = bonusSection as NewBonusSection;
  
  switch (insightKey) {
    case 'expert_insight': {
      const expertInsight = newBonusSection.expert_insight;
      return (
        <div>
          {expertInsight.title && <h4 className="font-semibold text-sm mt-2">{expertInsight.title}</h4>}
          {expertInsight.intro && <p className="text-sm mt-2">{expertInsight.intro}</p>}
          {renderListItems(expertInsight.key_takeaways)}
          {expertInsight.conclusion && (
            <p className="text-sm mt-3 text-muted-foreground">{expertInsight.conclusion}</p>
          )}
        </div>
      );
    }
    case 'unexpected_analogy': {
      const analogy = newBonusSection.unexpected_analogy;
      return (
        <div>
          {analogy.title && <h4 className="font-semibold text-sm mt-2">{analogy.title}</h4>}
          {analogy.intro && <p className="text-sm mt-2">{analogy.intro}</p>}
          {renderListItems(analogy.key_points)}
          {analogy.conclusion && (
            <p className="text-sm mt-3 text-muted-foreground">{analogy.conclusion}</p>
          )}
        </div>
      );
    }
    case 'challenged_assumption': {
      const assumption = newBonusSection.challenged_assumption;
      return (
        <div>
          {assumption.title && <h4 className="font-semibold text-sm mt-2">{assumption.title}</h4>}
          {assumption.intro && <p className="text-sm mt-2">{assumption.intro}</p>}
          {renderListItems(assumption.key_reasons)}
          {assumption.solution && (
            <p className="text-sm mt-3 font-medium">{assumption.solution}</p>
          )}
        </div>
      );
    }
    case 'insider_tip': {
      const tip = newBonusSection.insider_tip;
      return (
        <div>
          {tip.title && <h4 className="font-semibold text-sm mt-2">{tip.title}</h4>}
          {tip.intro && <p className="text-sm mt-2">{tip.intro}</p>}
          {renderListItems(tip.step_by_step)}
          {tip.final_takeaway && (
            <p className="text-sm mt-3 text-muted-foreground">{tip.final_takeaway}</p>
          )}
        </div>
      );
    }
    default:
      return null;
  }
};
